export default {
    测试: '测试',
    加载中: '加载中',
}
